import { render, staticRenderFns } from "./CDPSelector.vue?vue&type=template&id=a4cd8cbc&scoped=true&"
import script from "./CDPSelector.vue?vue&type=script&lang=js&"
export * from "./CDPSelector.vue?vue&type=script&lang=js&"
import style0 from "./CDPSelector.vue?vue&type=style&index=0&id=a4cd8cbc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4cd8cbc",
  null
  
)

export default component.exports